import { Role } from '@drl/core/store/models';
import {PatientCGStatus} from '../utility/patients-caregiver-utility.enum';
import {Gender} from '@drl/core/auth/models/gender.enum';

export class Caregiver {
  id?: number;
  userId?: number;
  patientExternalId: string;
  careGroupId?: number;
  phone: string;
  statusEnum?: PatientCGStatus;
  firstName: string;
  middleName?: string;
  lastName?: string;
  // dob?: string;
  genderEnum?: Gender;
  relation?: string;
  roleId: number;
  email?: string;
  photoUrl?: string; // sent in some apis from backend
  photoUrl1?: string; // sent in some apis from backend
  photoUrl2?: string; // sent in some apis from backend
  photoUrl3?: string; // sent in some apis from backend
  photoUrl4?: string; // sent in some apis from backend
  role?:Role
  lastOtp?: string;
  lastOtpDate?: Date;
  tncVersion?:number;
  isAgeEntered?:boolean;
  tncAcceptedDate?: Date;
  dob: Date;
  age: number;
  isMinor?: boolean;
  location?: string;
  selfOnbOn?:Date;
  get fullName(): string {
    let fullName = this.firstName;
    if (this.middleName) {
      fullName = fullName.concat(' ').concat(this.middleName);
    }
    if (this.lastName) {
      fullName = fullName.concat(' ').concat(this.lastName);
    }
    return fullName;
  }

  constructor(data?: Partial<Caregiver>) {
    Object.assign(this, data);
  }
}
